<div class="compound-navbar-link">
  <a #anchor [routerLink]="navLink" [state]="captureFocusNavState" [class.active]="isActive" [attr.aria-current]="ariaCurrent">
    <ng-content></ng-content>
  </a>
</div>
